export default {
  notices: [],
};
